<script>
  import { isEnglish, setIsEnglish } from "../stores/cookies.js";
  import { push } from "svelte-spa-router";
  let dropdownOpen = false;
  $: dropdownOptions = $isEnglish
    ? [
        "All",
        "Small Animals",
        "Production Animals",
        "Wildlife",
        "Equines",
        "Exotics",
      ]
    : [
        "Alle",
        "Klein Diere",
        "Produksie Diere",
        "Wild",
        "Perde",
        "Eksotiese Diere",
      ];
  let dropdownRef; // reference to the dropdown container

  function goToHome() {
    push("/");
    // or push('#/ourteam');  ← also works, but /ourteam is cleaner
  }

  function goToTeam() {
    push("/ourteam");
    // or push('#/ourteam');  ← also works, but /ourteam is cleaner
  }

  function goToLocations() {
    push("/");
    setTimeout(() => {
      const el = document.getElementById("Locations");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        console.warn(`Element with id="Locations" not found`);
      }
    }, 120);
    //push("/#Locations");
  }
</script>

<header
  class="bg-blue-600 text-white font-bold p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between"
>
  <!-- Left side: Logo + Text -->
  <div
    class="flex flex-col sm:flex-row sm:items-center sm:space-x-4 w-full sm:w-auto"
  >
    <!-- Logo -->
    <img
      src="assets/logo/logoOriginal.png"
      alt="Logo"
      class="w-full sm:w-[300px] object-contain block"
    />
  </div>

  <style>
    @media (max-width: 1200px) and (min-width: 640px) {
      #header-text {
        display: none;
      }
    }
  </style>

  <!-- Buttons for navigation-->
  <div class="flex justify-center mt-2 mb-2 ml-2 flex-wrap gap-2">
    <!-- Button 1 -->
    <button
      on:click={goToHome}
      class="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition"
    >
      {$isEnglish ? "Home" : "Tuis"}
    </button>

    <!-- Button 2 -->
    <button
      on:click={goToTeam}
      class="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition"
    >
      {$isEnglish ? "Our Team" : "Ons Span"}
    </button>

    <!-- Button 3 (Dropdown) -->
    <div class="relative" bind:this={dropdownRef}>
      <button
        class="px-4 py-2 rounded-md flex items-center space-x-1 transition
             text-white
             {dropdownOpen ? 'bg-blue-700' : 'bg-blue-600 hover:bg-blue-700'}"
        on:click={() => (dropdownOpen = !dropdownOpen)}
      >
        <span>{$isEnglish ? "Services" : "Dienste"}</span>
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {#if dropdownOpen}
        <!-- Invisible overlay to close on outside click -->
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
          class="fixed inset-0 z-0"
          on:click={() => (dropdownOpen = false)}
        ></div>

        <!-- Dropdown menu with white 2px border -->
        <ul
          class="absolute mt-2 right-0 w-40 bg-blue-600 text-white rounded-md shadow-lg z-10 border-2 border-black"
        >
          {#each dropdownOptions as option, i}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <li
              class="px-4 py-2 cursor-pointer hover:bg-blue-700
             {i === 0 ? 'rounded-t-md' : ''} {i === dropdownOptions.length - 1
                ? 'rounded-b-md'
                : ''}"
              on:click={() => {
                console.log("Clicked:", option, "index:", i);
                dropdownOpen = false;

                if (i >= 1 && i <= 5) {
                  i -= 1;
                  push("/services"); // or omit if you're already on /services

                  setTimeout(() => {
                    const el = document.getElementById(String(i));
                    if (el) {
                      el.scrollIntoView({ behavior: "smooth", block: "start" });
                    } else {
                      console.warn(`Element with id="${i}" not found`);
                    }
                  }, 120);
                } else {
                  push("/services");
                }
              }}
            >
              {option}
            </li>
          {/each}
        </ul>
      {/if}
    </div>

    <!-- Button 5 -->
    <button
      class="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition"
      on:click={() => push("/contact")}
    >
      {$isEnglish ? "Contact Us" : "Kontak Ons"}
    </button>
  </div>

  <div
    class="flex justify-center sm:justify-end flex-wrap mt-2 mb-2 mr-2 ml-2 gap-3 sm:gap-4"
  >
    <!-- Facebook button with icon + text -->
    <a
      href="https://www.facebook.com/vredenburgvet/"
      target="_blank"
      rel="noopener noreferrer"
      class="inline-flex items-center gap-2 px-3.5 sm:gap-3 sm:px-5 py-2 rounded-full
           bg-[#1877F2] text-white hover:text-white
           border border-white
           hover:bg-blue-600
           active:bg-blue-700
           focus-visible:outline-none focus-visible:ring-0
           transition-colors duration-200 shadow-sm text-sm sm:text-base font-medium
           no-underline hover:no-underline
           flex-shrink-0 min-w-[140px] sm:min-w-[180px] justify-center"
      aria-label="Visit our Facebook page"
    >
      <svg
        class="w-5 h-5 sm:w-6 sm:h-6 text-white flex-shrink-0"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path
          d="M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078V12h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.49 0-1.955.925-1.955 1.874V12h3.328l-.532 3.469h-2.796v8.385C19.612 22.954 24 17.99 24 12z"
        />
      </svg>
      <span class="text-white whitespace-nowrap">Visit Our Facebook</span>
    </a>
  </div>

  <!-- Language buttons -->
  <div
    class=" flex justify-center mt-2 mb-2 sm:justify-end space-x-2 w-full sm:w-auto"
  >
    <button
      class="px-3 py-1 rounded-full transition-colors duration-200
        {$isEnglish ? 'bg-blue-800 text-white' : 'bg-gray-200 text-black'}"
      on:click={() => setIsEnglish(true)}
    >
      English
    </button>

    <button
      class="px-3 py-1 rounded-full transition-colors duration-200
        {$isEnglish ? 'bg-gray-200 text-black' : 'bg-blue-800 text-white'}"
      on:click={() => setIsEnglish(false)}
    >
      Afrikaans
    </button>
  </div>
</header>

<div
  class="bg-white text-blue-700 py-3 px-4 flex flex-col sm:flex-row justify-end items-center gap-3 sm:gap-8 text-sm sm:text-base font-medium"
>
  <!-- Find Practice -->
  <button
    class="appearance-none border-none outline-none bg-transparent font-bold hover:underline hover:text-blue-900 transition"
    on:click={() => goToLocations()}
  >
    {$isEnglish ? "Find Your Nearest Practice" : "Vind Jou Naaste Praktyk"}
  </button>

  <!-- Divider (desktop only) -->
  <span class="hidden sm:inline text-gray-400">|</span>

  <!-- Emergency -->
  <!-- Emergency -->
  <a
    href="tel:0631128693"
    class="font-black text-red-600 hover:text-red-700 transition whitespace-pre-line text-xl sm:text-2xl"
    style="-webkit-text-stroke: 1px currentColor"
  >
    {$isEnglish
      ? "EMERGENCY AFTER HOURS: 063 112 8693"
      : "NOODGEVALLE NA URE: 063 112 8693"}
  </a>
</div>
